// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import { IconX } from "../components/icons.jsx";
import { metaPassRewardFromText } from "../metapassRewards.jsx";
import * as React from "react";
import * as jsxRuntime from "react/jsx-runtime";
import { IconChevronLeft } from "../components/icons.jsx";
import { IconCrown } from "../components/icons.jsx";
import { Ax } from "../assets.jsx";
export const Cm = () => {
  const u = new Date(),
    o = new Date(u.getTime() + 10800 * 1e3),
    m = Date.UTC(o.getUTCFullYear(), o.getUTCMonth() + 1, 1) - 10800 * 1e3;
  return Math.max(0, m - u.getTime());
};
export const Ex = u => {
  const [o, m] = String(u || "").split("-"),
    g = ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"][Number(m) - 1];
  return o && g ? `${g} ${o}` : "Текущий сезон";
};
export function buildMetaPassLevels(u) {
  const o = u || {
    free: [],
    paid: [],
    paidPlus: []
  };
  return Array.from({
    length: 70
  }, (m, r) => ({
    level: r + 1,
    free: metaPassRewardFromText(o.free[r] || "❌"),
    paid: metaPassRewardFromText(o.paid[r] || "❌"),
    paidPlus: metaPassRewardFromText(o.paidPlus[r] || "❌")
  }));
}
export function MetaPassPage({
  metapass: u,
  onBack: o,
  onPurchase: m,
  onClaim: r
}) {
  const g = u?.type === "paid" || u?.type === "paid_plus",
    j = u?.type === "paid_plus",
    B = u?.level ?? 0,
    U = u?.xp ?? 0,
    N = Math.max(u?.xpNeeded ?? 100, 1),
    y = Math.min(100, Math.round(U / N * 100)),
    [X, M] = React.useState(Cm),
    [R, H] = React.useState(null),
    [Y, P] = React.useState(!1),
    [W, ee] = React.useState(null),
    [ie, w] = React.useState(""),
    I = u?.freePick ?? 0,
    ne = u?.paidPick ?? 0,
    oe = u?.paidPlusPick ?? 0,
    T = g ? B : 0,
    D = j ? B : 0,
    le = I < B ? I + 1 : Number.POSITIVE_INFINITY,
    te = ne < T ? ne + 1 : Number.POSITIVE_INFINITY,
    Z = oe < D ? oe + 1 : Number.POSITIVE_INFINITY,
    V = Math.min(B, le, te, Z),
    [ae, Te] = React.useState(18),
    je = React.useRef(null),
    k = React.useRef(null),
    O = React.useRef(!1);
  Ex(u?.season);
  const L = window.Telegram?.WebApp?.BackButton;
  React.useEffect(() => {
    if (L) return L.show(), L.onClick(o), () => {
      L.offClick(o), L.hide();
    };
  }, [o, L]), React.useEffect(() => {
    const p = window.setInterval(() => M(Cm()), 6e4);
    return () => window.clearInterval(p);
  }, []), React.useEffect(() => {
    Te(p => Math.max(p, Math.min(70, V + 12)));
  }, [V]), React.useEffect(() => {
    if (ae >= 70 || !k.current) return;
    const p = new IntersectionObserver(([G]) => {
      G.isIntersecting && Te(F => Math.min(70, F + 16));
    }, {
      rootMargin: "520px"
    });
    return p.observe(k.current), () => p.disconnect();
  }, [ae]), React.useEffect(() => {
    if (O.current || ae < V) return;
    const p = window.setTimeout(() => {
      je.current?.querySelector(`[data-metapass-level="${Math.max(1, V)}"]`)?.scrollIntoView({
        block: "center"
      }), O.current = !0;
    }, 80);
    return () => window.clearTimeout(p);
  }, [V, ae]);
  const se = async p => {
      if (!(!R || Y)) {
        P(!0);
        try {
          (await m(p)) && H(null);
        } finally {
          P(!1);
        }
      }
    },
    C = async (p, G) => {
      const F = `${p}:${G}`;
      if (!W) {
        ee(F);
        try {
          await r(p, G);
        } finally {
          ee(null);
        }
      }
    },
    f = async p => {
      if (!W) {
        ee(`premium:${p}`);
        try {
          (await r("paid", p)) && (await r("paid_plus", p));
        } finally {
          ee(null);
        }
      }
    },
    h = () => {
      w("Сначала заберите предыдущую награду"), window.setTimeout(() => w(""), 2600);
    };
  return jsxRuntime.jsxs("section", {
    className: "mc-metapass-page",
    children: [!L && jsxRuntime.jsxs("button", {
      className: "mc-wallet-back",
      onClick: o,
      children: [jsxRuntime.jsx(IconChevronLeft, {}), "Назад"]
    }), jsxRuntime.jsx("section", {
      className: "mc-metapass-progress",
      children: jsxRuntime.jsxs("div", {
        className: "mc-metapass-track-controls",
        children: [jsxRuntime.jsxs("div", {
          className: "mc-metapass-level",
          children: [jsxRuntime.jsx("i", {
            children: jsxRuntime.jsx("span", {
              children: B
            })
          }), jsxRuntime.jsxs("em", {
            children: [jsxRuntime.jsx("span", {
              style: {
                width: `${y}%`
              }
            }), jsxRuntime.jsxs("b", {
              children: [jsxRuntime.jsx(IconCrown, {}), U.toLocaleString("ru-RU"), " / ", N.toLocaleString("ru-RU")]
            })]
          })]
        }), jsxRuntime.jsx("i", {}), jsxRuntime.jsx("button", {
          type: "button",
          "aria-label": j ? "MetaPass+ активен" : "Улучшить MetaPass",
          onClick: () => !j && H(g ? "paid_plus" : "paid"),
          className: `mc-metapass-upgrade-cta ${j ? "opened" : ""}`,
          children: j ? jsxRuntime.jsxs(jsxRuntime.Fragment, {
            children: [jsxRuntime.jsx(IconCrown, {}), jsxRuntime.jsxs("span", {
              children: [jsxRuntime.jsx("small", {
                children: "ПРЕМИУМ ДОСТУПЕН"
              }), jsxRuntime.jsx("b", {
                children: "MetaPass+ активен"
              })]
            }), jsxRuntime.jsx("strong", {
              children: "✓"
            })]
          }) : jsxRuntime.jsx("img", {
            src: Ax,
            alt: "Улучшить MetaPass"
          })
        })]
      })
    }), ie && jsxRuntime.jsx("div", {
      className: "mc-metapass-claim-hint",
      role: "status",
      children: ie
    }), jsxRuntime.jsxs("section", {
      className: "mc-metapass-rewards",
      ref: je,
      "aria-label": "Награды MetaPass",
      children: [buildMetaPassLevels(u?.rewards).slice(0, ae).map(p => {
        const G = p.level <= I,
          F = p.level <= ne,
          ce = p.level <= oe,
          ue = p.level <= B,
          Me = p.level <= B && g,
          Re = p.level <= B && j,
          wt = j && p.level === ne + 1 && p.level === oe + 1 && p.level <= B;
        return jsxRuntime.jsxs("div", {
          className: "mc-metapass-reward has-paid-plus",
          "data-metapass-level": p.level,
          children: [jsxRuntime.jsx(MetaPassRewardCell, {
            reward: p.free,
            available: ue,
            canClaim: p.level === I + 1,
            claimed: G,
            claiming: W === `free:${p.level}`,
            onClaim: () => {
              C("free", p.level);
            },
            onOutOfOrder: h
          }), jsxRuntime.jsx("b", {
            className: p.level <= B ? "available" : "",
            children: jsxRuntime.jsx("span", {
              children: p.level
            })
          }), jsxRuntime.jsxs("div", {
            className: "mc-metapass-premium-cell",
            children: [jsxRuntime.jsx(MetaPassRewardCell, {
              reward: p.paid,
              available: Me,
              canClaim: p.level === ne + 1,
              claimed: F,
              claiming: W === `paid:${p.level}` || W === `premium:${p.level}`,
              locked: !g,
              paid: !0,
              onLockedClick: () => H("paid"),
              onClaim: () => {
                C("paid", p.level);
              },
              onOutOfOrder: h
            }), jsxRuntime.jsx(MetaPassRewardCell, {
              reward: p.paidPlus,
              available: Re,
              canClaim: p.level === oe + 1,
              claimed: ce,
              claiming: W === `paid_plus:${p.level}` || W === `premium:${p.level}`,
              locked: !j,
              paid: !0,
              plus: !0,
              onLockedClick: () => H(g ? "paid_plus" : "paid"),
              onClaim: () => {
                C("paid_plus", p.level);
              },
              onOutOfOrder: h
            }), wt && jsxRuntime.jsx("button", {
              className: "mc-metapass-claim-pair",
              type: "button",
              disabled: !!W,
              onClick: () => {
                f(p.level);
              },
              children: W === `premium:${p.level}` ? "Получаем…" : "Забрать 2 награды"
            })]
          })]
        }, p.level);
      }), ae < 70 && jsxRuntime.jsx("div", {
        className: "mc-metapass-load-more",
        ref: k,
        "aria-label": "Загрузка следующих наград"
      })]
    }), R && jsxRuntime.jsxs("div", {
      className: "mc-metapass-offer",
      role: "dialog",
      "aria-modal": "true",
      "aria-label": "Предложение MetaPass",
      children: [jsxRuntime.jsx("button", {
        className: "mc-metapass-purchase-backdrop",
        "aria-label": "Закрыть",
        onClick: () => H(null)
      }), jsxRuntime.jsxs("section", {
        children: [jsxRuntime.jsxs("header", {
          children: [jsxRuntime.jsx("span", {
            children: "ПРЕМИАЛЬНЫЙ METAPASS"
          }), jsxRuntime.jsx("button", {
            className: "mc-icon-button",
            "aria-label": "Закрыть",
            onClick: () => H(null),
            children: jsxRuntime.jsx(IconX, { "aria-hidden": "true" })
          })]
        }), jsxRuntime.jsxs("div", {
          className: "mc-metapass-offer-content",
          children: [jsxRuntime.jsx(IconCrown, {}), jsxRuntime.jsx("small", {
            children: R === "paid" ? "META PASS" : "META PASS +"
          }), jsxRuntime.jsx("h2", {
            children: R === "paid" ? "Выбери свой пропуск" : "Открой Платный+"
          }), jsxRuntime.jsx("p", {
            children: R === "paid" ? "Платная дорожка или обе премиум-дорожки на всех 70 уровнях." : "Добавь дорожку Платный+ к своему пропуску на всех 70 уровнях."
          }), R === "paid" ? jsxRuntime.jsxs("div", {
            className: "mc-metapass-offer-options",
            children: [jsxRuntime.jsx("button", {
              className: "mc-metapass-offer-buy",
              type: "button",
              disabled: Y,
              onClick: () => {
                se("paid");
              },
              children: Y ? "Покупаем…" : "Платный — 149 коинов"
            }), jsxRuntime.jsx("button", {
              className: "mc-metapass-offer-buy mc-metapass-offer-buy-plus",
              type: "button",
              disabled: Y,
              onClick: () => {
                se("both");
              },
              children: Y ? "Покупаем…" : "Платный + Платный+ — 449 коинов"
            })]
          }) : jsxRuntime.jsx("button", {
            className: "mc-metapass-offer-buy",
            type: "button",
            disabled: Y,
            onClick: () => {
              se("paid_plus");
            },
            children: Y ? "Покупаем…" : "Добавить Платный+ за 300 коинов"
          })]
        })]
      })]
    })]
  });
}
export function MetaPassRewardCell({
  reward: u,
  available: o,
  canClaim: m = !1,
  claimed: r = !1,
  claiming: g = !1,
  locked: j = !1,
  paid: B = !1,
  plus: U = !1,
  repeating: N = !1,
  onLockedClick: y,
  onClaim: X,
  onOutOfOrder: M
}) {
  const R = o && m && !r && !j,
    H = o && !m && !r && !j,
    Y = j ? U ? "Нужен Платный+" : "Нужен Платный" : r ? "Получено" : g ? "Получаем…" : u.amount ? `× ${u.amount}` : N ? "× 3" : u.title === "Нет награды" ? "Пустой уровень" : R ? "Забрать" : o ? "Доступно" : "Скоро",
    P = j ? y : R ? X : H ? M : void 0;
  return jsxRuntime.jsxs("article", {
    className: `${o ? "available" : ""} ${B ? "paid" : ""} ${U ? "plus" : ""} ${j ? "locked" : ""} ${r ? "claimed" : ""} ${R || H ? "clickable" : ""}`,
    onClick: P,
    role: P ? "button" : void 0,
    tabIndex: P ? 0 : void 0,
    onKeyDown: P ? W => {
      (W.key === "Enter" || W.key === " ") && (W.preventDefault(), P?.());
    } : void 0,
    children: [jsxRuntime.jsx("i", {
      className: u.image ? "with-image" : "",
      children: u.image ? jsxRuntime.jsx("img", {
        src: u.image,
        alt: "",
        loading: "lazy",
        decoding: "async"
      }) : u.icon
    }), jsxRuntime.jsxs("span", {
      children: [jsxRuntime.jsx("b", {
        children: u.title
      }), jsxRuntime.jsx("small", {
        children: Y
      })]
    })]
  });
}
